import React, { useContext } from 'react';
import { Empty, Flex } from 'antd';

import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import { ticketStyles } from '@totem/components/ticketing/details/ticketStyles';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { buildingDisplayName } from '@totem/components/ui_components/constants';
import IBDIcon from '@totem/styles/Icon';
import { isNotNull, isNull } from '@totem/utilities/common';

const AuditItem = () => {
  const { data } = useContext(SurveyContext);

  if (isNull(data) || isNull(data.survey)) {
    return <Empty />;
  }

  return (
    <IBCard title={`${buildingDisplayName} Information`}>
      <Flex
        vertical
        justify="center"
        align="flex-start"
        style={{ fontSize: '18px', color: ticketStyles.colors.positive }}
      >
        <Flex justify="flex-start" align="center">
          <div style={{ marginRight: '2rem' }}>
            <IBDIcon name={'Organization'} />
          </div>
          <div>{data.organization.name}</div>
        </Flex>
        {isNotNull(data.building) && data.building.name !== '' && (
          <Flex justify="flex-start" align="center">
            <div style={{ marginRight: '2rem' }}>
              <IBDIcon name={'Building'} />
            </div>
            <div>{data.building.name}</div>
          </Flex>
        )}
        {isNotNull(data.controlSystem) && data.controlSystem.name !== '' && (
          <Flex justify="flex-start" align="center">
            <div style={{ marginRight: '2rem' }}>
              <IBDIcon name={'Control System'} />
            </div>
            <div>{data.controlSystem.name}</div>
          </Flex>
        )}
      </Flex>
    </IBCard>
  );
};

export default AuditItem;
